import { get, normalizeUri } from '../../../utils/utils';
import { ItemKind } from '../../../constants/ItemKind';
import { MediaType } from '../../../constants/MediaType';
export function toItem(data) {
  if (data.media_type === 'image') {
    const thumbnailUrl = normalizeUri(data.mosaic_url);
    const previewUrl = normalizeUri(get(data, 'assets.preview_1000.url'));
    return {
      id: data.id,
      name: data.description,
      source: 'shutterStock',
      kind: ItemKind.File,
      folderId: null,
      mediaType: MediaType.Picture,
      mimeType: 'image/jpeg',
      fileUrl: null,
      thumbnailUrl,
      previewUrl,
      createdAt: null,
      tags: [],
      fileInfo: {
        aspect: data.aspect
      },
      width: null,
      height: null
    };
  }
  const thumbnailUrl = normalizeUri(get(data, 'assets.thumb_jpg.url'));
  const previewUrl = normalizeUri(get(data, 'assets.preview_mp4.url'));
  return {
    id: data.id,
    name: data.description,
    source: 'shutterStock',
    kind: ItemKind.File,
    folderId: null,
    mediaType: MediaType.Video,
    mimeType: 'video/mp4',
    fileUrl: null,
    thumbnailUrl,
    previewUrl: thumbnailUrl,
    videoPreviewUrls: [previewUrl],
    createdAt: null,
    tags: get(data, 'keywords', []),
    fileInfo: {
      aspect: data.aspect
    },
    fileInput: {
      duration: data.duration * 1000
    },
    width: get(data, 'assets.hd.width', null),
    height: get(data, 'assets.hd.height', null)
  };
}